import { forwardRef, HTMLAttributes, ReactNode, RefObject, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import mergeRefs from 'merge-refs'

import { cn } from '@/lib/utils'

export type MediaParallaxProps = Omit<
  HTMLAttributes<HTMLSpanElement>,
  'children'
> & {
  // eslint-disable-next-line no-unused-vars
  children: (ref: RefObject<HTMLImageElement>) => ReactNode
}

const MediaParallax = forwardRef<HTMLSpanElement, MediaParallaxProps>(
  ({ children, className, ...props }, forwardRef) => {
    const ref = useRef<HTMLSpanElement>(null)
    const refs = mergeRefs(ref, forwardRef)
    const media = useRef<any>(null!)

    useGSAP(
      () => {
        if (media.current instanceof HTMLVideoElement) return

        gsap.to(media.current, {
          scrollTrigger: {
            trigger: ref.current,
            start: 'top 100%',
            end: 'bottom 0%',
            markers: false,
            scrub: true,
            once: false
          },
          yPercent: -13,
          ease: 'none'
        })

        return () => {
          gsap.killTweensOf(media.current)
        }
      },
      { scope: ref }
    )

    return (
      <span
        ref={refs}
        className={cn('block overflow-hidden [&_img]:!h-[115%]', '', className)}
        {...props}
      >
        {children(media)}
      </span>
    )
  }
)

export default MediaParallax
